module.exports = __webpack_public_path__ + "static/media/new2.e79b7edb.png";